module.exports = __webpack_public_path__ + "static/media/ArrowNext.239e09f2.svg";